import MenuComponent from '@/components/MenuComponent'
import ActualitesComponent from '@/components/ActualitesComponent'
import MenuConnexion from '@/components/MenuConnexion'
import BlocAuthenticated from '@/components/BlocAuthenticated'
import { OperationSearch } from '@/models/operationssearch.model'

export default {
  data () {
    return {
      rechercheParcCartes: new OperationSearch(),
      loading: false,
      currentPage: 1,
      perPage: 20,
      totalItems: 0,
      pages: 1
    }
  },
  components: {
    MenuComponent,
    MenuConnexion,
    BlocAuthenticated,
    ActualitesComponent
  },
  methods: {
    getCivility (civility) {
      if (civility === '1') {
        return 'M. '
      }
      if (civility === '3') {
        return 'Melle '
      }
      if (civility === '2') {
        return 'Mme '
      }
    },
    getRetraitLabel (retrait) {
      switch (retrait) {
        case 'O': // oui
          return 'oui'
        case 'N': // non
          return 'non'
        default:
          return null
      }
    },
    getCompteReglementLabel (compteReglement) {
      switch (compteReglement) {
        case 'E': // Entreprise
          return 'Entreprise'
        case 'P': // Porteur
          return 'Porteur'
        default:
          return '-'
      }
    },
    getEtatCarteLabel (carte) {
      var moment = require('moment')
      this.dateDeValidite = carte.dateValidite
      this.dateCloture = carte.closeDate
      if (this.dateDeValidite && this.dateCloture) {
        this.dateValiditeFormatee = moment(this.dateDeValidite, 'YYYYMM').add(1, 'M').format('YYYY-MM-DD')
        this.dateClotureFormatee = moment(this.dateCloture).format('YYYY-MM-DD')
        if (this.dateValiditeFormatee >= moment().format('YYYY-MM-DD') && this.dateClotureFormatee === '9999-12-31') {
          return 'active'
        }
      }
      return 'inactive'
    },
    getEntityLevel (entityLevel) {
      switch (entityLevel) {
        case '0':
          return 'Entreprise - '
        case '1':
          return 'Direction - '
        case '2':
          return 'Sous-Direction - '
        default:
          break
      }
    },
    changeAvailablePage () {
      this.getParcCartes(this.currentPage - 1)
    },
    getParcCartes (beginIndex) {
      this.rechercheParcCartes.beginIndex = this.perPage * beginIndex
      this.rechercheParcCartes.endIndex = parseInt(this.rechercheParcCartes.beginIndex) + this.perPage

      if (this.$store.state.user.user.selectedEntreprise) {
        this.rechercheParcCartes.entrepriseId = this.$store.state.user.user.selectedEntreprise.entrepriseId

        this.loading = true
        this.$store.dispatch('entreprise/getParcCartes', this.rechercheParcCartes).then(
          response => {
            this.loading = false
            this.totalItems = this.$store.state.entreprise.parcCartes.nbTotalCards
            this.pages = Math.ceil(this.totalItems / this.perPage)
          },
          error => {
            this.errorMessage = error.response
            this.loading = false
          }
        )
      }
    }
  },
  created () {
    if (!this.$store.state.entreprise || !this.$store.state.entreprise.parcCartes || !this.$store.state.entreprise.parcCartes.length) {
      this.getParcCartes(0)
    }
  },
  beforeCreate () {
    this.$store.state.filArianePage = 'Parc de cartes'
    this.$store.state.filArianeMiddlePage = null
    this.$store.state.filArianeMiddleRouterLink = null
  }
}
